import styled from 'styled-components';
import color from '../../configs/color';
// import breakpoints from '../../configs/breakpoints'

const Wrapper = styled.div`
  margin-top: 20px;

  .component_general_information_avatar {
    width: 168px;
    height: 168px;
    border-radius: 90px;
    background-color: ${color.grey2};
  }

  .component_general_information_form {
    margin-top: 24px;
    display: flex;
  }

  .component_general_information_avatar {
    position: relative;
    color: ${color.black4};
    font-size: 5.5em;

    .anticon {
      position: absolute;
      top: 44px;
      left: 44px;
    }
  }

  .component_general_information_image {
    position: relative;
    margin-right: 94px;
  }

  .component_general_information_upload {
    background-color: ${color.green1};
    width: 42px;
    height: 42px;
    display: inline-block;
    border-radius: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    right: 0;

    .anticon {
      color: ${color.white};
      margin-top: 5px;
    }
  }

  .component_general_information_form_content {
    width: 574px;
  }

  .component_general_information_jobs_org {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 24px;
  }
`;

export default Wrapper;
